import { WorksheetContextMenuComponent } from './worksheet-context-menu/worksheet-context-menu.component';
import { FlagsService } from './../../services/flags.service';
import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, ViewContainerRef, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AbstractItem } from '@business/base/abstract-item';
import { AbstractItemService } from '@business/base/abstract-item.service';
import { Box } from '@business/home/workspace-new/workspace-new.component';
import { WorksheetConfigModalComponent } from '@business/worksheet/worksheet-config-modal/worksheet-config-modal.component';
import { AutoCompleteComponent } from '@component/auto-complete/auto-complete.component';
import { MessageQuote } from '@model/webFeeder/message-quote.model';
import { BilletOrderModalService } from '@services/billet-order-modal.service';
import { QuoteService } from '@services/webFeeder/sckt-quotes.service';
import { WorkspaceNewService } from '@services/workspace-new.service';
import { AppUtils } from '@utils/app.utils';
import { Comparators } from '@utils/comparators.utils';
import { Constants } from '@utils/constants';
import { GridApi, GridOptions } from 'ag-grid';
import { NotificationsService } from 'angular2-notifications';
import { Subscription, of } from 'rxjs';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { ConfigService } from '@services/webFeeder/config.service';
import { ConfirmationModalComponent } from '@component/confirmation-modal/confirmation-modal.component';
import { WorksheetShareModel } from '@model/worksheet-share.model';
import { WorksheetShareService } from '@services/worksheet-share.service';
import { CrudOperationEnum } from '@model/enum/crud-operation.enum';
import { MarketEnum } from '@model/enum/market.enum';

@Component({
  selector: Constants.WINDOW_NAME_WORK_SHEET,
  templateUrl: './worksheet.component.html',
})
export class WorksheetComponent extends AbstractItem implements OnInit, OnDestroy {
  listSymbol = [];
  newWindow = false;
  windowActive: any;
  loading = true;
  editRow: number;
  title = Constants.TITLE_CARD_WORKSHEET;
  titleInput = this.title;
  editTitleFlag = false;
  rowSelection;
  checkedItems = false;
  checkIndeterminate = false;
  lengthChecked = 0;
  gridOptions: GridOptions;
  filterOn = false;
  listColumns = Constants.worksheetCols.slice(0, 17);
  lastTradeList = [];
  rowData: any[] = [];
  columnDefs: any[] = [];
  override dialog: MatDialog;
  defaultColDef;
  rowDataOldValue: string;
  rowDataIndex: any;
  rowDataValue: any;
  rowDataUnsubscribe = 0;
  isStart: boolean;
  insertNewQuote: boolean;
  lastTradeTemp = 0;
  showExpandCard = this.configService.getShowExpandCard(Constants.WINDOW_NAME_WORK_SHEET);
  private gridApi: GridApi;
  private subscriptionQuote: Subscription;
  protected override workspaceService: WorkspaceNewService;
  doubleClickedTab = null;
  selectedWorksheetDefault: boolean;
  selectedWorksheetIndex: any;
  selectedWorksheetDefaultIndex: any;
  selectedWorksheetId: any;
  listShareWorksheets: WorksheetShareModel[] = [];
  listShareDefaultWorksheets: WorksheetShareModel[] = [];
  worksheetSelected: WorksheetShareModel = new WorksheetShareModel();
  isFirstGetWorksheetShare: boolean;
  organization = this.configService.getConfigWhitelabel();
  waitloadingWkstDefault: boolean;
  isFirstLoadingWkshtShare = true;
  oldSelectedWorksheetId: number;
  isRequestServer: boolean;
  messageRequestServer = Constants.MSG01_REQUEST;
  messageAddWorksheet = Constants.WORKSPACE_MSG029;
  removeFromWksTooltip = Constants.TOOLTIP_REMOVE_WKS_TOOL;
  isWksOffline: boolean;
  worksheetFirstLoaded = false;
  loggedNegotiation: boolean;

  @Input() override data: Box;
  @ViewChild('inputTitle') inputTitle: ElementRef;
  @ViewChild('inputFilter') inputFilter: ElementRef;
  @ViewChild('worksheet', { read: ViewContainerRef }) parent: ViewContainerRef;
  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.editingStopped();
    }
  }

  constructor(dialog: MatDialog, workspaceService: WorkspaceNewService, itemService: AbstractItemService, private quoteService: QuoteService, private route: ActivatedRoute, private billetOrderModalService: BilletOrderModalService, private el: ElementRef, private configService: ConfigService, private notificationService: NotificationsService, private datePipe: DatePipe, private flagService: FlagsService, private _worksheetShareService: WorksheetShareService) {
    super(workspaceService, dialog, itemService);
    const self = this;
    this.gridOptions = <GridOptions>{
      headerHeight: 32,
      rowHeight: 25,
      enableColResize: true,
      onDragStopped: (params) => {
        this.saveHeader();
      },
      processRowPostCreate: (params) => {
        this.generateRowEvents(params, self);
      },
      getRowNodeId: (data) => {
        return data.id;
      },
      localeText: { noRowsToShow: Constants.MSG_NO_DATA_TO_SHOW },
      context: { componentParent: this, scope: this },
    };
    this.dialog = dialog;
    this.workspaceService = workspaceService;
    this.isWksOffline = this.configService.getCookieWorkspace() === Constants.WKS_NAME_OFFLINE;
    this._worksheetShareService.reloadWorksheetAfterNewAction$.subscribe((res) => {
      if (res) {
        this.isRequestServerOnOff(true);
        setTimeout(() => {
          this.getListWorksheetShare(false, res);
        }, 20);
      }
    });
    this.configService.authHbLogged$.subscribe((res) => {
      this.loggedNegotiation = res;
    });
  }

  ngOnInit() {
    this.worksheetSelected.Title = 'Carregando...';
    this.lastTradeTemp = 0;
    this.initWks();
  }

  initWks() {
    setTimeout(() => {
      this.setListSymbolParams();
      if (this.data) {
        this.setColums();
        this.getListWorksheetShare(this.organization.worksheet.showWorksheetShareDefault);
        if (this.data.worksheetTitle) {
          this.title = this.data.worksheetTitle;
          this.titleInput = this.data.worksheetTitle;
        }
      } else if (this.listColumns) {
        this.setColums();
      }
    }, 0);
  }

  setListSymbolParams() {
    let listUserColumnsTemp;
    const listColumns = Constants.worksheetCols;
    this.route.queryParams.subscribe((params) => {
      if (params['symbol']) {
        this.newWindow = true;
        if (typeof params['symbol'] === 'string') {
          this.listSymbol = [params['symbol']];
        } else {
          this.listSymbol = params['symbol'];
        }
      }
      if (params['columns']) {
        this.listColumns = [];
        listUserColumnsTemp = params['columns'];
        for (let i = 0; i < listUserColumnsTemp.length; i++) {
          for (let x = 0; x < listColumns.length; x++) {
            if (listUserColumnsTemp[i] === listColumns[x].field) {
              this.listColumns.push(listColumns[x]);
              break;
            }
          }
        }
      }
      this.loading = false;
    });
  }

  setColums() {
    const defaultMaxWidth = 150;
    this.columnDefs = [];
    this.columnDefs.push({
      colId: 'id',
      headerName: 'id',
      field: 'id',
      hide: true,
    });
    this.columnDefs.push({
      headerName: '',
      width: 35,
      maxWidth: 35,
      suppressMovable: true,
    });
    if (this.data && this.data.columns && this.data.columns.length > 0) {
      this.listColumns = [];
      this.data.columns.forEach((element) => {
        const configColumn = Constants.worksheetCols.find((x) => x.field === element.field);
        const columns = {
          id: configColumn.id,
          field: element.field,
          class: configColumn.class,
          header: configColumn.header,
          headerClass: configColumn.headerClass,
          width: element.width,
          isDefault: configColumn.isDefault,
        };
        this.listColumns.push(columns);
      });
    }
    const quote = this.listColumns ? this.listColumns.find((x) => x.field === 'ativo') : null;
    if (!quote) {
      this.listColumns = Constants.worksheetCols;
      this.data.columns = this.listColumns;
      super.updateContentOnDemand();
    }
    this.listColumns.forEach((element) => {
      if (element.field === 'ativo') {
        this.columnDefs.push({
          headerName: '[S]',
          field: 'variationArrow',
          cellRenderer: this.renderVariationArrow,
          suppressCellFlash: true,
          cellClass: 'txt-center',
          headerClass: 'txt-center',
          width: 38,
          maxWidth: 38,
        });
        this.columnDefs.push({
          headerName: element.header,
          field: 'ativo',
          maxWidth: 202,
          editable: true,
          cellEditorFramework: AutoCompleteComponent,
          comparator: this.stringComparator,
          cellClass: 'txt-left',
          headerClass: 'txt-left',
          width: element.width,
        });
        this.columnDefs.push({
          headerName: '[B]',
          width: 38,
          maxWidth: 38,
          field: 'flag',
          cellRenderer: this.renderFlag,
          suppressMovable: false,
        });
      } else if (element.field === 'variation') {
        this.columnDefs.push({
          headerName: element.header,
          field: element.field,
          cellRenderer: this.renderVariation,
          maxWidth: defaultMaxWidth,
          suppressCellFlash: true,
          cellClass: element.class,
          headerClass: element.headerClass,
          width: element.width,
        });
      } else if (element.field === 'variationArrow') {
        this.columnDefs.push({
          headerName: element.header,
          field: element.field,
          cellRenderer: this.renderVariationArrow,
          maxWidth: defaultMaxWidth,
          suppressCellFlash: true,
          cellClass: element.class,
          headerClass: element.headerClass,
          width: element.width,
        });
      } else if (element.field === 'description') {
        this.columnDefs.push({
          headerName: element.header,
          field: element.field,
          comparator: this.stringComparator,
          cellRenderer: this.renderTooltip,
          cellClass: element.class,
          headerClass: element.headerClass,
          width: element.width,
        });
      } else if (element.field === 'lastTrade') {
        this.columnDefs.push({
          headerName: element.header,
          field: element.field,
          comparator: this.valueComparator,
          cellRenderer: this.renderLastTrade,
          suppressCellFlash: true,
          width: element.width,
          maxWidth: defaultMaxWidth,
          cellClass: element.class,
          headerClass: element.headerClass,
        });
      } else if (element.field === 'bid') {
        this.columnDefs.push({
          headerName: element.header,
          field: element.field,
          cellRenderer: this.renderBuy,
          valueFormatter: this.priceFormatter,
          suppressCellFlash: true,
          width: element.width,
          maxWidth: defaultMaxWidth,
          cellClass: element.class,
          headerClass: element.headerClass,
        });
      } else if (element.field === 'ask') {
        this.columnDefs.push({
          headerName: element.header,
          field: element.field,
          cellRenderer: this.renderSell,
          valueFormatter: this.priceFormatter,
          suppressCellFlash: true,
          width: element.width,
          maxWidth: defaultMaxWidth,
          cellClass: element.class,
          headerClass: element.headerClass,
        });
      } else if (element.field === 'timeUpdate') {
        this.columnDefs.push({
          headerName: element.header,
          field: element.field,
          valueFormatter: this.timeFormatter,
          width: element.width,
          maxWidth: defaultMaxWidth,
          cellClass: element.class,
          headerClass: element.headerClass,
        });
      } else if (element.field === 'dateTrade') {
        this.columnDefs.push({
          headerName: element.header,
          field: element.field,
          valueFormatter: this.timeFormatter,
          width: element.width,
          maxWidth: defaultMaxWidth,
          cellClass: element.class,
          headerClass: element.headerClass,
        });
      } else if (element.field === 'open') {
        this.columnDefs.push({
          headerName: element.header,
          field: element.field,
          valueFormatter: this.timeFormatter,
          width: element.width,
          maxWidth: defaultMaxWidth,
          cellClass: element.class,
          headerClass: element.headerClass,
        });
      } else if (element.field === 'typeOption') {
        this.columnDefs.push({
          headerName: element.header,
          field: element.field,
          valueFormatter: this.typeConvert,
          width: element.width,
          maxWidth: defaultMaxWidth,
          cellClass: element.class,
          headerClass: element.headerClass,
        });
      } else if (element.field === 'tickDirection') {
        this.columnDefs.push({
          headerName: element.header,
          field: element.field,
          cellRenderer: this.renderTickDirection,
          width: element.width,
          maxWidth: defaultMaxWidth,
          cellClass: element.class,
          headerClass: element.headerClass,
        });
      } else if (element.field === 'deltaVolumeCurrentTime') {
        this.columnDefs.push({
          headerName: '<i class="fa fa-sort-asc delta"></i> ' + element.header,
          field: element.field,
          width: element.width,
          maxWidth: defaultMaxWidth,
          cellClass: element.class,
          headerClass: element.headerClass,
          cellRenderer: this.renderBgVolume,
        });
      } else if (element.field === 'deltaVolumeAccumulatedHour') {
        this.columnDefs.push({
          headerName: '<i class="fa fa-sort-asc delta"></i> ' + element.header,
          field: element.field,
          width: element.width,
          maxWidth: defaultMaxWidth,
          cellClass: element.class,
          headerClass: element.headerClass,
          cellRenderer: this.renderBgVolume,
        });
      } else if (element.field === 'calculoWeeklyVariation') {
        this.columnDefs.push({
          headerName: element.header,
          field: element.field,
          cellRenderer: this.renderVariation,
          maxWidth: defaultMaxWidth,
          suppressCellFlash: true,
          cellClass: element.class,
          headerClass: element.headerClass,
          width: element.width,
        });
      } else if (element.field === 'calculoMonthlyVariation') {
        this.columnDefs.push({
          headerName: element.header,
          field: element.field,
          cellRenderer: this.renderVariation,
          maxWidth: defaultMaxWidth,
          suppressCellFlash: true,
          cellClass: element.class,
          headerClass: element.headerClass,
          width: element.width,
        });
      } else if (element.field === 'calculoYearlyVariation') {
        this.columnDefs.push({
          headerName: element.header,
          field: element.field,
          cellRenderer: this.renderVariation,
          maxWidth: defaultMaxWidth,
          suppressCellFlash: true,
          cellClass: element.class,
          headerClass: element.headerClass,
          width: element.width,
        });
      } else {
        this.columnDefs.push({
          headerName: element.header,
          field: element.field,
          width: element.width,
          maxWidth: 300,
          cellClass: element.class,
          headerClass: element.headerClass,
        });
      }
    });
    this.defaultColDef = {
      width: 150,
      maxWidth: 300,
      headerCheckboxSelection: this.isFirstColumn,
      headerCheckboxSelectionFilteredOnly: true,
      checkboxSelection: this.isFirstColumn,
      suppressKeyboardEvent: function (event) {
        if (event.editing) {
          return true;
        }
      },
    };
    this.rowSelection = 'multiple';
  }

  ngOnDestroy() {
    this.closeSheet();
    if (this.subscriptionQuote) {
      this.subscriptionQuote.unsubscribe();
    }
    if (this.listSymbol.length > 0) {
      this.listSymbol.forEach((element, index) => {
        this.quoteService.unsubscribeQuote(element, Constants.WINDOW_NAME_WORK_SHEET);
      });
    }
  }

  saveChanges(operation: CrudOperationEnum, symbol?, company?, indexListWkstShare?) {
    if (this.selectedWorksheetDefault) {
      return;
    }
    const aglist = [];
    this.gridApi.forEachNode(function (node) {
      if (node && node.data && node.data.ativo !== '') {
        aglist.push(node.data.ativo.toUpperCase());
      }
    });
    if (operation === CrudOperationEnum.POST && symbol) {
      const newSymbol = { symbol: symbol.toUpperCase(), company: company };
      this.worksheetSelected.Assets.push(newSymbol);
    } else if (operation === CrudOperationEnum.PUT) {
      this.worksheetSelected.Assets[indexListWkstShare].symbol = symbol.toUpperCase();
      this.worksheetSelected.Assets[indexListWkstShare].company = company;
    }

    this.worksheetSelected.Assets = this.worksheetSelected.Assets.filter((item) => aglist.includes(item.symbol.toUpperCase()));
    this.updateWorksheetShare(this.worksheetSelected);
  }

  setQuote(symbol: string, index: number, indexListWkstShare: number) {
    symbol = symbol ? AppUtils.trimStart(symbol).toLowerCase() : null;
    if (!symbol && symbol !== '') {
      return;
    }
    if (this.validSymbol(symbol)) {
      if (this.worksheetSelected && !this.worksheetSelected.Assets.find((x) => x.symbol.toLowerCase() === symbol.toLowerCase())) {
        this.saveChanges(indexListWkstShare !== null && indexListWkstShare !== undefined && indexListWkstShare >= 0 ? CrudOperationEnum.PUT : CrudOperationEnum.POST, symbol, null, indexListWkstShare);
      }
      if (indexListWkstShare !== null && indexListWkstShare !== undefined && indexListWkstShare >= 0) {
        this.quoteService.unsubscribeQuote(this.worksheetSelected.Assets[indexListWkstShare].symbol, Constants.WINDOW_NAME_WORK_SHEET);
      }
      this.quoteService.subscribeQuote(symbol, Constants.WINDOW_NAME_WORK_SHEET);
      this.subscriptionQuote = this.quoteService.messagesQuote.subscribe((msg: MessageQuote) => {
        if (msg && msg.errorMessage && msg.symbol.toLowerCase() === symbol.toLowerCase()) {
          if (this.rowDataUnsubscribe === 0) {
            if (this.quoteService.subscribeQuote(msg.symbol, Constants.WINDOW_NAME_WORK_SHEET)) {
              this.quoteService.unsubscribeQuote(msg.symbol, Constants.WINDOW_NAME_WORK_SHEET);
            }
            this.treatmenInvalidQuote(msg, this.data.id);
          }
        } else if (msg !== undefined && msg.symbol != null && msg.symbol.toLowerCase() === symbol.toLowerCase()) {
          this.rowDataUnsubscribe = 0;
          if (this.editRow !== index) {
            const list = [];
            this.gridApi.forEachNode(function (node) {
              list.push(node);
            });
            list.forEach((data) => {
              if (data.data.ativo === msg.symbol.toUpperCase()) {
                this.setData(msg, data.rowIndex);
              }
            });
          }
        }
      });
    }
  }

  private treatmenInvalidQuote(msg, wksId?) {
    if (this.insertNewQuote) {
      this.notificationService.warn('', Constants.WORKSPACE_MSG007);
    } else {
      if (Constants.WORKSPACE_MSG030 && msg.symbol && this.data.id == wksId) {
        const messageShow = Constants.WORKSPACE_MSG030.replace('{{quote}}', msg.symbol.toUpperCase()).replace('{{card}}', Constants.TITLE_CARD_WORKSHEET);
        this.notificationService.warn('', messageShow);
      }
    }
    let oldValue = 'novo';
    let oldAssetValue = '';
    if (this.rowDataOldValue && this.rowDataOldValue !== '') {
      oldValue = this.rowDataOldValue.toUpperCase();
      oldAssetValue = this.rowDataOldValue.toUpperCase();
    }
    const dataEmpty = this.emptyRow();
    dataEmpty.id = oldValue;
    dataEmpty.ativo = oldAssetValue;
    if (oldValue && oldValue.toUpperCase() != 'NOVO') {
      this.listSymbol[this.rowDataIndex] = oldValue.toUpperCase();
    }
    setTimeout(() => {
      if (oldAssetValue === '') {
        this.gridApi.removeItems([this.gridApi.getRowNode(this.listSymbol[this.listSymbol.length - 1])]);
        this.listSymbol.splice(this.listSymbol.length - 1, 1);
        this.editRow = null;
        this.saveChanges(CrudOperationEnum.DELETE);
      } else {
        this.listSymbol[this.listSymbol.length - 1] = dataEmpty.id.toUpperCase();
        this.gridApi.updateRowData({
          remove: [{ id: msg.symbol.toUpperCase() }],
          add: [dataEmpty],
          addIndex: this.rowDataIndex,
        });
        msg = new MessageQuote();
        this.rowDataUnsubscribe = 1;
        this.quoteService.subscribeQuote(this.rowDataOldValue, Constants.WINDOW_NAME_WORK_SHEET);
        if (!this.newWindow) {
          this.saveChanges(null);
        }
      }
    }, 0);
  }

  private validSymbol(symbol): boolean {
    const quote = this.quoteService.acessListQuotes(symbol);
    if (quote && quote[0] && quote[0].values) {
      if (quote[0].values.hasOwnProperty('-1')) {
        this.treatmenInvalidQuote(quote[0]);
        return false;
      }
      return true;
    } else {
      return true;
    }
  }

  openNewWindow() {
    if (!this.data.symbol) {
      this.notificationService.warn('', 'Necessário ter pelo menos um ativo na planilha de cotação.');
      return;
    }
    let parameters = '';
    let first = true;
    this.gridApi.forEachNode(function (node) {
      if (node.data.ativo && node.data.ativo !== '') {
        if (first) {
          parameters = parameters + '?symbol=' + node.data.ativo;
          first = false;
        } else {
          parameters = parameters + '&symbol=' + node.data.ativo;
        }
      }
    });
    if (this.data && this.data.columns) {
      this.data.columns.forEach((element) => {
        parameters = parameters + '&columns=' + element.field;
      });
    }
    const options = 'width=' + this.el.nativeElement.offsetParent.offsetWidth + 'px, height=' + this.el.nativeElement.offsetParent.offsetHeight + 'px';
    if (this.windowActive == null || this.windowActive.closed) {
      super.getNewWindow(Constants.WINDOW_NAME_WORK_SHEET, parameters, options, this.data.id).subscribe((window) => {
        this.windowActive = window;
      });
    } else {
      this.windowActive.focus();
    }
  }

  closeSheet() {
    if (this.windowActive != null) {
      this.windowActive.close();
    }
  }

  toggleEditTitle() {
    if (this.selectedWorksheetDefault) {
      return;
    }
    this.editTitleFlag = !this.editTitleFlag;
    if (this.editTitleFlag) {
      this.titleInput = this.title;
      setTimeout(() => {
        this.inputTitle.nativeElement.focus();
      }, 100);
    }
  }

  checkTitle() {
    if (this.titleInput !== '' && this.isAlphanumeric(this.titleInput)) {
      this.title = this.titleInput.toUpperCase();
      if (this.titleInput !== this.data.worksheetTitle) {
        this.data.worksheetTitle = this.titleInput.toUpperCase();
        super.updateContentOnDemand();
      }
    } else {
      this.notificationService.warn('', 'O nome da planilha deve conter pelo menos 1 caracter alfanumérico.');
    }
    this.toggleEditTitle();
  }

  checkColumns(listColumns: any) {
    if (listColumns && this.data) {
      this.data.columns = listColumns;
      super.updateContentOnDemand();
    } else {
      this.listColumns = listColumns;
    }
  }

  isAlphanumeric(txt) {
    let code = null;
    for (let i = 0; i < txt.length; i++) {
      code = txt.charCodeAt(i);
      if ((code > 47 && code < 58) || (code > 64 && code < 91) || (code > 96 && code < 123)) {
        return true;
      }
    }
    return false;
  }

  renderFlag(param) {
    let cellContent: string = '';
    if (param.value) {
      cellContent = '<img class="flag" src="./assets/images/svg/flags/' + param.value + '.svg">';
    }
    return cellContent;
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }

  timeFormatter(params) {
    if (params.value && params.value.length === 12) {
      return params.value.substring(0, params.value.length - 4);
    } else {
      return params.value;
    }
  }

  priceFormatter(params) {
    if (params.value === undefined) {
      return '0,00';
    } else {
      return params.value;
    }
  }

  typeConvert(params) {
    if (params.value === 'E') {
      return 'Européia';
    } else if (params.value === 'A') {
      return 'Americana';
    } else {
      return '';
    }
  }

  valueComparator(value1, value2) {
    return Comparators.brFormattedNumberComparator(value1, value2);
  }

  stringComparator(value1, value2, nodea, nodeb, inverted) {
    if (value1 === '' && inverted) {
      return 1;
    }
    if (value1 === '' && !inverted) {
      return -1;
    }
    if (value1 > value2) {
      return 1;
    }
    if (value1 < value2) {
      return -1;
    }
    return 0;
  }

  renderBuy(param) {
    if (!param.value || param.value === '0,00' || param.value === '0' || param.value === '-') {
      return '';
    }
    return '<span class="buy-span">' + param.value + '</span>';
  }

  renderSell(param) {
    if (!param.value || param.value === '0,00' || param.value === '0' || param.value === '-') {
      return '';
    }
    return '<span class="sell-span">' + param.value + '</span>';
  }

  renderLastTrade(param) {
    if (param.value) {
      let variationClass = '';
      let colorClass = '';
      if (param.data.variation && !moment(param.data.variation.toString(), 'DD/MM/YYYY', true).isValid()) {
        const variation = parseFloat(param.data.variation);
        if (variation > 0) {
          variationClass = 'positive-renderer';
          colorClass = 'high-color';
        } else if (variation < 0) {
          variationClass = 'negative-renderer';
          colorClass = 'low-color';
        }
      }
      return '<div class="' + variationClass + '"><span class="' + colorClass + ' weight-500">' + param.value + '</span></div>';
    }
    return '';
  }

  renderVariation(param) {
    if (param.value) {
      const valueNumber = parseFloat(param.value);
      const valueDate = param.value.toString().split('/');
      if (valueDate.length > 1) {
        return '<span>' + param.value + '</span>';
      } else if (valueNumber > 0) {
        return '<span class="high-color">+' + AppUtils.numberToFormattedNumber(valueNumber) + '</span>';
      } else if (valueNumber < 0) {
        return '<span class="low-color">' + AppUtils.numberToFormattedNumber(valueNumber) + '</span>';
      }
    }
    return '0,00';
  }

  renderBgVolume(param) {
    if (param.value) {
      const valueNumber = parseFloat(param.value.replace(',', '.'));
      if (valueNumber == 0) {
        return '<div ><span ></span></div>';
      } else if (valueNumber > 0 && valueNumber <= 100) {
        return '<div class="bg-green-color"><span class="high-color;weight-500">' + AppUtils.numberToFormattedNumber(valueNumber) + '%</span></div>';
      } else if (valueNumber >= 100.1 && valueNumber <= 200) {
        return '<div class="bg-yellow-color"><span class="low-color;weight-500">' + AppUtils.numberToFormattedNumber(valueNumber) + '%</span></div>';
      } else if (valueNumber >= 200.1) {
        return '<div class="bg-red-color"><span class="low-color;weight-500">' + AppUtils.numberToFormattedNumber(valueNumber) + '%</span></div>';
      }
    }
  }

  renderVariationArrow(param) {
    let imgClass = null;
    if (param.value === 'fa-arrow-down') {
      imgClass = '<span><i class="fa fa-arrow-down low-color"></i></span>';
    } else if (param.value === 'fa-arrow-up') {
      imgClass = '<span><i class="fa fa-arrow-up high-color"></i></span>';
    } else if (param.value === 'fa-gavel') {
      imgClass = '<span><i class="fa fa-gavel hammer"></i></span>';
    } else if (param.value === 'fa-square') {
      imgClass = '<span><i class="fa fa-square zero"></i></span>';
    }
    return imgClass;
  }

  renderTickDirection(param) {
    const img = param && (param.value === '+' || param.value === '0+') ? 'arrow_up_variation' : param && (param.value === '-' || param.value === '0-') ? 'arrow_down_variation' : null;
    return img ? '<img class="arrow-high" src="./assets/images/svg/' + img + '.ico">' : null;
  }

  renderTooltip(param) {
    if (param.value) {
      return '<span title="' + param.value + '">' + param.value + '</span>';
    } else {
      return '';
    }
  }

  setData(msg: MessageQuote, i: any) {
    if (this.gridApi) {
      const rowNode = this.gridApi.getDisplayedRowAtIndex(i);
      if (rowNode) {
        let varAjustp = 0;
        let varAjust = 0;
        let varTeor = 0;
        let lastTradeConst = 0;
        let previousAdjustConst = 0;
        let theoryPriceConst = 0;
        let previousConst = 0;
        const variationArrow = '';
        if (msg.lastTrade && msg.lastTrade.toString() !== '-' && msg.lastTrade.toString() !== '0,00' && msg.lastTrade.toString() !== '0') {
          lastTradeConst = AppUtils.convertBrCurrencyToNumber(msg.lastTrade.toString(), ',');
        }
        if (msg.previousAdjustPrice && msg.previousAdjustPrice.toString() !== '-') {
          previousAdjustConst = AppUtils.convertBrCurrencyToNumber(msg.previousAdjustPrice.toString(), ',');
        }
        if (msg.theoryPrice && (msg.theoryPrice > 0 || (msg.theoryPrice.toString() !== '-' && Number(msg.theoryPrice.toString().replace(',', '.'))))) {
          theoryPriceConst = AppUtils.convertBrCurrencyToNumber(msg.theoryPrice.toString(), ',');
        }
        if (msg.previous && msg.previous.toString() !== '-' && msg.previous.toString() !== '0,00' && msg.previous.toString() !== '0') {
          previousConst = AppUtils.convertBrCurrencyToNumber(msg.previous.toString(), ',');
        }
        if (lastTradeConst > 0 && previousAdjustConst > 0) {
          varAjustp = (lastTradeConst / previousAdjustConst - 1) * 100;
          if (varAjustp !== 0) {
            varAjustp = Number(Number(varAjustp).toFixed(2));
          }
          varAjust = lastTradeConst - previousAdjustConst;
        }
        if (theoryPriceConst > 0 && previousConst > 0) {
          varTeor = (theoryPriceConst / previousConst - 1) * 100;
          if (varTeor !== 0) {
            varTeor = Number(Number(varTeor).toFixed(2));
          }
        }
        const data = {
          id: msg.symbol.toUpperCase(),
          ativo: msg.symbol.toUpperCase(),
          flag: this.flagService.getAssetFlag(msg.symbol.toUpperCase(), msg.marketType),
          varAjustp: AppUtils.convertNumberToCurrency(varAjustp, null, '') + '%',
          varAjust: AppUtils.convertNumberToCurrency(varAjust, null, '') + '%',
          varTeor: AppUtils.convertNumberToCurrency(varTeor, null, '') + '%',
          lastTrade: this.lastTradeList[i],
          variationArrow: variationArrow,
        };
        const tickSize = msg.marketType !== MarketEnum.BITCOIN ? msg.tickSize : 3;
        this.listColumns.forEach((element) => {
          if (element.field === 'ativo') {
            data[element.field] = msg['symbol'].toUpperCase();
          } else if (element.field !== 'varAjustp' && element.field !== 'varAjust' && element.field !== 'varTeor') {
            data[element.field] = msg[element.field];
          }
          if (msg && element.field === 'variation') {
            const newDate = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
            if (msg[element.field] && (msg[element.field].toString() === '-' || msg[element.field].toString() === '0.0' || msg[element.field] === 0) && newDate !== msg.dateLastNegotiation) {
              data[element.field] = msg.dateLastNegotiation;
            }
          }
          if (msg && msg[element.field] && msg[element.field] !== '-' && ['lastTrade', 'open', 'high', 'low', 'previous', 'previousYear', 'average', 'theoryPrice', 'exercisePrice'].includes(element.field)) {
            const lastTradeNumber = AppUtils.convertFormattedNumberToNumber(msg[element.field]);
            data[element.field] = AppUtils.numberToCurrency(lastTradeNumber, tickSize);
          }
          if (msg && msg[element.field] && msg[element.field] !== '-' && ['bid', 'ask'].includes(element.field)) {
            if (msg.marketType === MarketEnum.BOVESPA || msg.marketType === MarketEnum.BMF) {
              const lastTradeNumber = AppUtils.convertFormattedNumberToNumber(msg[element.field]);
              data[element.field] = AppUtils.numberToCurrency(lastTradeNumber, tickSize);
            } else {
              data[element.field] = null;
            }
          }
          if (msg && msg[element.field] && msg[element.field] !== '-' && ['volumeAmount', 'volumeFinancier'].includes(element.field)) {
            const isOptimized = /.(K|M|B)$/.test(msg[element.field]);
            if (isOptimized) {
              data[element.field] = msg[element.field];
            } else {
              const valueAsNumber = Number(msg[element.field]);
              data[element.field] = valueAsNumber < 1000 ? AppUtils.numberToFormattedNumber(valueAsNumber, 0) : AppUtils.convertNumberToOptimizedNumber(valueAsNumber);
            }
          }
          if (msg.calculoWeeklyVariation) {
            msg.calculoWeeklyVariation = Number(msg.calculoWeeklyVariation.toString().replace(',', '.'));
          }
          if (msg.calculoMonthlyVariation) {
            msg.calculoMonthlyVariation = Number(msg.calculoMonthlyVariation.toString().replace(',', '.'));
          }
          if (msg.calculoYearlyVariation) {
            msg.calculoYearlyVariation = Number(msg.calculoYearlyVariation.toString().replace(',', '.'));
          }
          data['variationArrow'] = msg.theoryPrice && (msg.theoryPrice > 0 || (msg.theoryPrice.toString() !== '-' && Number(msg.theoryPrice.toString().replace(',', '.')))) ? 'fa-gavel' : msg.variation && Number(msg.variation) > 0 ? 'fa-arrow-up' : msg.variation && Number(msg.variation) < 0 ? 'fa-arrow-down' : msg.variation && Number(msg.variation) === 0 ? 'fa-square' : '';
        });
        data['lastTradeTemp'] = this.lastTradeList[i];
        let company = '';
        if (msg.description && msg.description !== '' && msg.classification.trim() !== '0') {
          company = msg.description.trim() + ' ' + msg.classification.trim();
        } else {
          company = msg.description.trim();
        }
        data['description'] = company;
        this.gridApi.updateRowData({ update: [data] });
      }
      this.lastTradeList[i] = msg.lastTrade;
    }
  }

  onGridReady(param) {
    if (param && param.api) {
      this.gridApi = param.api;
    }
    this.isStart = true;
    this.listSymbol.forEach((element, index) => {
      this.gridApi.updateRowData({ add: [{ id: element.toUpperCase(), ativo: element.toUpperCase() }] });
      if (this.newWindow) {
        setTimeout(() => {
          this.setQuote(element, index, null);
        }, 2000);
      } else {
        this.setQuote(element, index, null);
      }
    });
    this.isStart = false;
  }

  onCellValueChanged(event) {
    this.rowDataOldValue = event.oldValue;
    this.rowDataIndex = event.rowIndex;
    const rowUpdateWkstOldIndex = this.worksheetSelected ? this.worksheetSelected.Assets.findIndex((x) => x.symbol === this.rowDataOldValue) : null;
    let rowDataValue;
    const newValue = event.newValue;
    if (event.data.data) {
      rowDataValue = event.data.data;
    } else {
      rowDataValue = event.data;
    }
    const existentRowNode = this.gridApi.getRowNode(newValue.toUpperCase());
    if (!this.selectedWorksheetDefault && newValue !== '' && newValue.toUpperCase() !== this.rowDataOldValue.toUpperCase() && existentRowNode === undefined) {
      this.listSymbol[this.rowDataIndex] = newValue.toUpperCase();
      this.gridApi.updateRowData({
        remove: [{ id: rowDataValue.id }],
        add: [
          {
            id: newValue.toUpperCase(),
            ativo: newValue.toUpperCase(),
          },
        ],
        addIndex: event.rowIndex,
      });
      this.insertNewQuote = true;
      this.setQuote(newValue, rowDataValue.id, rowUpdateWkstOldIndex);
    } else {
      if (newValue !== this.rowDataOldValue && !this.selectedWorksheetDefault) {
        if (existentRowNode === undefined || existentRowNode === null) {
          this.notificationService.warn('', Constants.WORKSPACE_MSG007);
        } else {
          this.insertNewQuote = false;
          this.notificationService.warn('', Constants.WORKSPACE_MSG017);
        }
      }
      const newData = rowDataValue;
      if (this.rowDataOldValue) {
        newData.ativo = this.rowDataOldValue;
      } else {
        newData.ativo = '';
      }
      this.gridApi.updateRowData({ update: [newData] });
      return;
    }
    this.gridApi.forEachNode(function (rowNodet) {
      rowNodet.setDataValue('setRandom', 5);
    });
  }

  onRemoveTableWorksheet() {
    if (this.gridApi !== undefined) {
      const selectedData = this.gridApi.getSelectedRows();
      const worksheetSelectedTemp = this.worksheetSelected;
      selectedData.forEach((item) => {
        const indexToRemoveWshtShare = this.worksheetSelected ? this.worksheetSelected.Assets.findIndex((i) => i.symbol.toLowerCase() === item.ativo.toLowerCase()) : null;
        if (indexToRemoveWshtShare !== undefined && indexToRemoveWshtShare > -1) {
          worksheetSelectedTemp.Assets.splice(indexToRemoveWshtShare, 1);
        }
      });
      const operationType = { operation: CrudOperationEnum.DELETE };
      this.updateWorksheetShare(worksheetSelectedTemp, null, operationType);
    }
  }

  onRemoveSelected() {
    if (this.gridApi !== undefined) {
      const selectedData = this.gridApi.getSelectedRows();
      selectedData.forEach((item) => {
        const indexToRemove = this.listSymbol ? this.listSymbol.findIndex((i) => i.toLowerCase() == item.ativo.toLowerCase()) : null;
        if (indexToRemove != undefined && indexToRemove > -1) {
          this.listSymbol.splice(indexToRemove, 1);
        }
        const indexToRemoveWshtShare = this.worksheetSelected ? this.worksheetSelected.Assets.findIndex((i) => i.symbol.toLowerCase() === item.ativo.toLowerCase()) : null;
        if (indexToRemoveWshtShare != undefined && indexToRemoveWshtShare > -1) {
          this.worksheetSelected.Assets.splice(indexToRemoveWshtShare, 1);
        }
      });
      this.gridApi.updateRowData({ remove: selectedData });
      selectedData.forEach((element) => {
        this.quoteService.unsubscribeQuote(element.ativo.toUpperCase(), Constants.WINDOW_NAME_WORK_SHEET);
      });
      this.subscriptionQuote.unsubscribe();

      if (this.gridApi.getDisplayedRowCount() <= 0) {
        this.workspaceService.resizeComponent({ componentId: this.data.id, rows: 1, cols: null });
      }
      this.saveChanges(CrudOperationEnum.DELETE);
    }
  }

  removeGrid() {
    super.removeItemFromWorkspace();
  }

  emptyRow() {
    const data = { id: '', ativo: '' };
    this.listColumns.forEach((element) => {
      if (element.field !== 'lastTrade') {
        data[element.field] = '';
      } else {
        data[element.field] = '0';
      }
    });
    return data;
  }

  addNew() {
    if (this.selectedWorksheetDefault) {
      this.configService.systemNotificationMessage('', Constants.WORKSPACE_MSG040, Constants.ALERT_TYPE.info);
      return;
    }
    let add = true;
    const length = this.gridApi.getDisplayedRowCount();
    if (length >= Constants.QTD_MAX_ASSETS_WORKSHEET) {
      add = false;
      this.notificationService.warn('', Constants.WORKSHEET_MAX_ASSETS_MSG);
      return;
    }
    this.gridApi.forEachNode(function (node) {
      if (node.data.ativo === '' || node.data.ativo === undefined) {
        add = false;
        return;
      }
    });
    if (add) {
      this.listSymbol.push('');
      const data = this.emptyRow();
      data.id = 'novo';
      this.gridApi.updateRowData({ add: [data], addIndex: this.listSymbol.length - 1 });
      setTimeout(() => {
        const newRow = this.gridApi.getRowNode('novo');
        this.gridApi.setFocusedCell(newRow.rowIndex, 'ativo');
        this.gridApi.startEditingCell({ rowIndex: newRow.rowIndex, colKey: 'ativo' });
      }, 10);
    }
  }

  openFilter() {
    this.toggleFilter();
  }

  destroyFilter() {
    this.gridApi.destroyFilter('ativo');
  }

  filterAsset(valueFilter) {
    const filterInput = {
      ativo: {
        type: 'contains',
        filter: valueFilter,
      },
    };
    this.gridApi.setFilterModel(filterInput);
    this.gridApi.onFilterChanged();
  }

  keyup(event) {
    this.filterAsset(event.target.value);
  }

  keyCell($event) {}

  symbolChanged(event) {
    this.filterAsset(event.symbol);
  }

  closeFilter() {
    this.destroyFilter();
    this.filterOn = false;
  }

  toggleFilter() {
    if (!this.filterOn) {
      setTimeout(() => {
        document.getElementById('input-filter').getElementsByTagName('input')[0].focus();
      }, 400);
    }
    document.getElementById('input-filter').getElementsByTagName('input')[0].value = '';
    this.destroyFilter();
    this.filterOn = !this.filterOn;
  }

  onCellClicked(event) {
    if (this.newWindow) {
      return;
    }
    if ((event.event.target.className === 'buy-renderer' || event.event.target.className === 'buy-span') && event.data.ask !== '-' && event.data.bid !== '-') {
      this.billetOrderModalService.buySellOrder('sell', event.data.ativo, event.data.bid);
    } else if ((event.event.target.className === 'sell-renderer' || event.event.target.className === 'sell-span') && event.data.ask !== '-' && event.data.bid !== '-') {
      this.billetOrderModalService.buySellOrder('buy', event.data.ativo, event.data.ask);
    }
  }

  validateSelectedForBillet(asset?) {
    const selectedAsset = asset || (this.gridApi.getSelectedNodes().length > 0 && this.gridApi.getSelectedNodes()[0].data);
    return selectedAsset && selectedAsset.ask !== '-' && selectedAsset.bid !== '-';
  }

  openBuyOrSellBilletFromSelected(action) {
    const selectedAsset = this.gridApi.getSelectedNodes()[0].data;
    if (this.validateSelectedForBillet(selectedAsset)) {
      if (action == 'buy') {
        this.billetOrderModalService.buySellOrder(action, selectedAsset.ativo, selectedAsset.bid);
      } else {
        this.billetOrderModalService.buySellOrder(action, selectedAsset.ativo, selectedAsset.ask);
      }
    }
  }

  generateRowEvents(params, parent) {
    params.eRow.draggable = true;
    params.eRow.ondragstart = (event: DragEvent) => {
      parent.newRowIndex = params.node.rowIndex;
      parent.currentRowIndex = params.node.rowIndex;
    };
    params.eRow.ondragenter = (event: DragEvent) => {
      parent.newRowIndex = params.node.rowIndex;
    };
    params.eRow.ondragleave = (event: DragEvent) => {
      parent.newRowIndex = params.node.rowIndex;
    };
    params.eRow.ondragover = (event: DragEvent) => {
      parent.newRowIndex = params.node.rowIndex;
    };
    params.eRow.ondragend = (event: DragEvent) => {
      const sortmodel = parent.gridOptions.api.getSortModel();
      if (sortmodel.length === 0 && parent.newRowIndex > -1 && parent.newRowIndex !== params.node.rowIndex) {
        const record = params.node.data;
        const rowData = [];
        this.gridApi.forEachNode(function (node) {
          rowData.push(node.data);
        });
        parent.gridOptions.api.setRowData(rowData);
        rowData.splice(parent.newRowIndex, 0, rowData.splice(parent.currentRowIndex, 1)[0]);
        if (this.listSymbol && this.listSymbol.length > 0) {
          this.listSymbol.splice(parent.newRowIndex, 0, this.listSymbol.splice(parent.currentRowIndex, 1)[0]);
        }
        if (this.worksheetSelected && this.worksheetSelected.Assets && this.worksheetSelected.Assets.length > 0) {
          this.worksheetSelected.Assets.splice(parent.newRowIndex, 0, this.worksheetSelected.Assets.splice(parent.currentRowIndex, 1)[0]);
        }
        parent.gridOptions.api.removeItems([params.node], false);
        parent.gridOptions.api.insertItemsAtIndex(parent.newRowIndex, [record], false);
        this.gridApi.forEachNode(function (rowNode) {
          rowNode.setDataValue('setRandom', 5);
        });
        this.saveChanges(CrudOperationEnum.DELETE);
      } else {
        parent.newRowIndex = -1;
      }
    };
  }

  editingStarted(event) {
    if (this.selectedWorksheetDefault) {
      this.configService.systemNotificationMessage('', Constants.WORKSPACE_MSG040, Constants.ALERT_TYPE.info);
      this.gridApi.stopEditing();
      return;
    }
    this.editRow = event.rowIndex;
  }

  editingStopped(event?) {
    let nodeToExclude;
    this.gridApi.forEachNode(function (node) {
      if (node.data.ativo === '' || node.data.ativo === undefined) {
        nodeToExclude = node;
        return;
      }
    });
    if (nodeToExclude) {
      this.gridApi.removeItems([nodeToExclude]);
    }
    const removeIndex = this.listSymbol.indexOf('');
    if (removeIndex != undefined && removeIndex != -1) {
      this.listSymbol.splice(removeIndex, 1);
    }
    this.editRow = null;
  }

  onSelectionChanged(event) {
    if (this.selectedWorksheetDefault && event.api.getSelectedNodes().length > 0) {
      this.configService.systemNotificationMessage('', Constants.WORKSPACE_MSG040, Constants.ALERT_TYPE.info);
      return;
    }
    const length = this.gridApi.getDisplayedRowCount();
    this.lengthChecked = event.api.getSelectedNodes().length;
    if (this.lengthChecked > 0) {
      if (this.lengthChecked === length) {
        this.checkedItems = true;
        setTimeout(() => {
          this.checkIndeterminate = false;
        }, 100);
      } else {
        this.checkIndeterminate = true;
        this.checkedItems = false;
      }
    } else {
      this.checkedItems = false;
      this.checkIndeterminate = false;
    }
  }

  changeCheck(event) {
    if (event.checked) {
      this.gridApi.selectAllFiltered();
    } else {
      this.gridApi.deselectAllFiltered();
    }
  }

  openConfig(event) {
    let topPosition = event.y - 14;
    const leftPosition = event.x - 212;
    let bottomArrow = false;
    if (topPosition + 325 >= window.innerHeight && event.y - 10 - 325 > 0) {
      topPosition = event.y - 197;
      bottomArrow = true;
    }
    const dialogRef = this.dialog.open(WorksheetConfigModalComponent, {
      width: '290px',
      height: '340.8px',
      position: { left: leftPosition + 'px', top: topPosition + 'px' },
      panelClass: 'worksheet-config-modal-container',
      backdropClass: 'worksheet-config-modal-backdrop',
      disableClose: true,
      data: {
        columns: this.listColumns,
        bottomArrow: bottomArrow,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data && result.data.length > 0) {
        const listTemp = [];
        const newTemp = [];
        let indexTemp = 0;
        if (this.data && this.data.columns && this.data.columns.length > 0) {
          this.data.columns.forEach((element) => {
            element.indexOrder = indexTemp++;
          });
        }
        if (result.data && result.data.length) {
          for (let i = 0; i < result.data.length; i++) {
            const temp = this.data && this.data.columns && this.data.columns.length > 0 ? this.data.columns.find((item) => item.field === result.data[i].field) : null;
            if (temp) {
              listTemp.push(temp);
            } else {
              newTemp.push(result.data[i]);
            }
          }
          AppUtils.orderObjectAscNumberBillet(listTemp, 'indexOrder');
          if (newTemp && newTemp.length > 0) {
            newTemp.forEach((element) => {
              listTemp.push(element);
            });
          }
          this.listColumns = listTemp;
        }
      } else {
        this.listColumns = Constants.worksheetCols.slice(0, 17);
      }
      this.checkColumns(this.listColumns);
      this.setColums();
    });
  }

  @HostListener('contextmenu')
  onTriggerContextMenu() {
    event.preventDefault(); // prevent browser contextMenu opening
  }

  onCellContextMenu(event) {
    if (event && event.data && event.data.ativo) {
      const topPosition = event.event.y;
      const leftPosition = event.event.x - 48;
      const dialogRef = this.dialog.open(WorksheetContextMenuComponent, {
        width: '120px',
        height: '104px',
        position: {
          left: leftPosition + 'px',
          top: topPosition + 'px',
        },
        panelClass: 'worksheet-context-menu-modal-container',
        backdropClass: 'worksheet-context-menu-modal-backdrop',
      });
      dialogRef.componentInstance.assetSymbol = event.data.ativo;
    }
  }

  saveHeader() {
    const order = this.gridOptions.columnApi.getAllGridColumns().map((item) => {
      return { id: item.getColId(), width: item.getActualWidth() };
    });
    const reorder = [];
    const currentOrder = this.listColumns || null;
    order.map((x) => {
      const column = currentOrder ? currentOrder.find((col) => col.field === x.id) : null;
      if (column) {
        column.width = x.width;
        reorder.push(column);
      }
    });
    this.data.columns = reorder;
    super.updateContentOnDemand();
  }

  getListWorksheetShare(isDefaultWkstShare, update?) {
    // GET - Busca as planilhas compartilhadas e seleciona o ID
    // TODO: Modo Debug
    // console.log('\n\n------------------------------- INICIO getListWorksheetShare() ----------------------------------');
    // console.log('\n\ngetListWorksheetShare() > WKS ID: ' + this.data.id + ' - isFirstLoadingWkshtShare: ' + this.isFirstLoadingWkshtShare);
    if (!this.selectedWorksheetId && this.isFirstLoadingWkshtShare) {
      this.selectedWorksheetId = this.data && this.data.data && this.data.data.selected_worksheet ? this.data.data.selected_worksheet : null;
    }
    // console.log('getListWorksheetShare() > WKS ID: ' + this.data.id + ' - selectedWorksheetId:', this.selectedWorksheetId);
    // console.log('getListWorksheetShare() > WKS ID: ' + this.data.id + ' - idWorksheet:', update ? update.selectecWksht : null);
    // console.log('getListWorksheetShare() > WKS ID: ' + this.data.id + ' - newSelectedWorksheetId:', this.oldSelectedWorksheetId + ' !== selectedWorksheetId: ' + this.selectedWorksheetId);
    if (!update || (update && update.planID !== this.data.id) || (update && update.planID === this.data.id && update.selectecWksht !== this.oldSelectedWorksheetId)) {
      this.getPlanWkst(isDefaultWkstShare);
    } else {
      this.isRequestServerOnOff(false);
    }
  }

  getPlanWkst(isDefaultWkstShare) {
    setTimeout(() => {
      this.isRequestServerOnOff(true);
      this._worksheetShareService.getWorksheetsShare(isDefaultWkstShare).subscribe(
        (res) => {
          if (res && res.length > 0) {
            this.waitloadingWkstDefault = isDefaultWkstShare;
            AppUtils.orderObjectStringAsc(res, 'Title');
            if (isDefaultWkstShare) {
              this.listShareDefaultWorksheets = res;
              this.listShareDefaultWorksheets.forEach((element) => {
                element.Title = element.Title.toUpperCase();
              });
            } else {
              this.listShareWorksheets = res;
              this.listShareWorksheets.forEach((element) => {
                element.Title = element.Title.toUpperCase();
              });
            }
            if (!this.waitloadingWkstDefault) {
              this.changeWorksheetShare(null);
            } else {
              if (!this.isWksOffline) {
                this.getPlanWkst(false);
              } else {
                this.isRequestServerOnOff(false);
                this.changeWorksheetShare(null);
              }
            }
          } else {
            if (isDefaultWkstShare) {
              this.getListWorksheetShare(false);
            } else {
              this.isFirstGetWorksheetShare = true;
              this.newWorksheetShare();
            }
          }
          // TODO: Modo Debug
          // if (!this.waitloadingWkstDefault) {
          // console.log('\n\n------------------------------- FIM getListWorksheetShare() ----------------------------------\n');
          // }
        },
        (error) => {
          this.isRequestServerOnOff(false);
          this.notificationService.error('', Constants.WORKSHEET_MSG006);
        }
      );
    }, 500);
  }

  changeWorksheetShare(wkshtId: number, action?) {
    this.checkedItems = false;
    this.configService.writeLog(Constants.WINDOW_NAME_WORK_SHEET + ' > ----------------------------- START | changeWorksheetShare() | Planilha ID: ' + this.data.id + ' -----------------------------');
    this.configService.writeLog(this.listShareWorksheets, Constants.WINDOW_NAME_WORK_SHEET + ' > Lista de Planilhas (listShareWorksheets): ');
    this.configService.writeLog(this.listShareDefaultWorksheets, Constants.WINDOW_NAME_WORK_SHEET + ' > Lista de Planilhas Default (listShareDefaultWorksheets): ');
    this.configService.writeLog(this.data, Constants.WINDOW_NAME_WORK_SHEET + ' > Config da Planilha (DATA): ');
    this.configService.writeLog(this.data.selected_worksheet, Constants.WINDOW_NAME_WORK_SHEET + ' > Planilha selecionada (data.selected_worksheet) (ID): ');
    this.configService.writeLog(this.data.data.selected_worksheet, Constants.WINDOW_NAME_WORK_SHEET + ' > Planilha selecionada (data.data.selected_worksheet) (ID): ');
    this.configService.writeLog(this.selectedWorksheetId, Constants.WINDOW_NAME_WORK_SHEET + ' > Planilha selecionada (selectedWorksheetId) (ID): ');
    this.configService.writeLog(wkshtId, Constants.WINDOW_NAME_WORK_SHEET + ' > Planilha selecionada (wkshtId) (ID): ');
    this.configService.writeLog(this.selectedWorksheetDefault, Constants.WINDOW_NAME_WORK_SHEET + ' > Planilha Pre Definida: (selectedWorksheetDefault): ');
    this.configService.writeLog(this.isFirstLoadingWkshtShare, Constants.WINDOW_NAME_WORK_SHEET + ' > Primeiro acesso: (isFirstLoadingWkshtShare): ');
    if (this.gridApi) {
      this.gridApi.setRowData([]);
    }
    const selectedWorksheetIndex = this.listShareWorksheets ? this.listShareWorksheets.findIndex((x) => (wkshtId ? x.Id === wkshtId : x.Id === this.data.data.selected_worksheet)) : null;
    this.configService.writeLog(selectedWorksheetIndex, Constants.WINDOW_NAME_WORK_SHEET + ' > Index Plan: (selectedWorksheetIndex): ');
    const selectedWorksheetDefaultIndex = this.listShareDefaultWorksheets ? this.listShareDefaultWorksheets.findIndex((x) => (wkshtId ? x.Id === wkshtId : x.Id === this.data.data.selected_worksheet)) : null;
    this.configService.writeLog(selectedWorksheetDefaultIndex, Constants.WINDOW_NAME_WORK_SHEET + ' > Index Plan Pré-Definida: (selectedWorksheetDefaultIndex): ');

    if (selectedWorksheetIndex >= 0) {
      this.worksheetSelected = this.listShareWorksheets[selectedWorksheetIndex];
      this.selectedWorksheetId = this.listShareWorksheets[selectedWorksheetIndex].Id;
      this.selectedWorksheetIndex = selectedWorksheetIndex;
      this.configService.writeLog(this.worksheetSelected.Title, Constants.WINDOW_NAME_WORK_SHEET + ' > Planilha (' + selectedWorksheetIndex + '):  ');
      this.selectedWorksheetDefault = false;
    } else if (selectedWorksheetDefaultIndex >= 0) {
      this.worksheetSelected = this.listShareDefaultWorksheets[selectedWorksheetDefaultIndex];
      this.selectedWorksheetId = this.listShareDefaultWorksheets[selectedWorksheetDefaultIndex].Id;
      this.selectedWorksheetIndex = selectedWorksheetDefaultIndex;
      this.configService.writeLog(this.worksheetSelected.Title, Constants.WINDOW_NAME_WORK_SHEET + ' > Planilha (' + selectedWorksheetDefaultIndex + '):  ');
      this.selectedWorksheetDefault = true;
    } else if (this.isWksOffline) {
      this.worksheetSelected = this.listShareDefaultWorksheets[0];
      this.selectedWorksheetId = this.listShareDefaultWorksheets[0].Id;
      this.selectedWorksheetIndex = 0;
      this.configService.writeLog(this.worksheetSelected.Title, Constants.WINDOW_NAME_WORK_SHEET + ' > Planilha (' + 0 + '):  ');
      this.selectedWorksheetDefault = true;
    } else {
      this.worksheetSelected = this.listShareWorksheets[0];
      this.selectedWorksheetId = this.listShareWorksheets[0].Id;
      this.selectedWorksheetIndex = 0;
      this.configService.writeLog(this.worksheetSelected.Title, Constants.WINDOW_NAME_WORK_SHEET + ' > Planilha (' + selectedWorksheetIndex + '):  ');
      this.selectedWorksheetDefault = this.isWksOffline ? true : false;
    }

    if (this.listSymbol && this.listSymbol.length > 0) {
      this.listSymbol.forEach((element, index) => {
        this.quoteService.unsubscribeQuote(element, Constants.WINDOW_NAME_WORK_SHEET);
      });
    }
    this.listSymbol = [];
    if (this.worksheetSelected && this.worksheetSelected.Assets && this.worksheetSelected.Assets.length > 0) {
      this.worksheetSelected.Assets = AppUtils.removeValueDuplicated(this.worksheetSelected.Assets, 'symbol');
      this.worksheetSelected.Assets.forEach((element) => {
        if (element.symbol && element.symbol.toLowerCase().indexOf('-us') < 0) {
          if (!this.listSymbol.find((x) => x === element.symbol)) {
            this.listSymbol.push(element.symbol);
          }
        }
      });
      this.configService.writeLog(this.listSymbol, Constants.WINDOW_NAME_WORK_SHEET + ' > List Symbol: ');
      this.onGridReady(null);
    }
    this.isFirstLoadingWkshtShare = false;
    this.saveWorsheetSelected(this.worksheetSelected.Id);
    this.isRequestServerOnOff(false);
    this.configService.writeLog(Constants.WINDOW_NAME_WORK_SHEET + ' > ----------------------------- END | changeWorksheetShare() | Planilha ID: ' + this.data.id + ' -----------------------------');
  }

  deleteWorksheetShare(wksht: WorksheetShareModel, event, removeQuote: boolean) {
    if (removeQuote) {
      this.onRemoveTableWorksheet();
    } else {
      if (event) {
        event.stopPropagation();
      }
      if (!wksht.Id) {
        this.notificationService.error('', Constants.WORKSHEET_MSG002);
      } else if (this.listShareWorksheets && this.listShareWorksheets.length <= 1) {
        this.notificationService.error('', Constants.WORKSHEET_MSG008);
      } else {
        const dialogConfig = this.dialog.open(ConfirmationModalComponent, {
          panelClass: Constants.NORMAL_MODAL,
        });
        dialogConfig.componentInstance.title = 'Atenção';
        dialogConfig.componentInstance.content = Constants.WORKSHEET_MSG003 + '<br><br><b>' + wksht.Title.toUpperCase() + '</b>';
        dialogConfig.afterClosed().subscribe((result) => {
          if (result) {
            this.isRequestServerOnOff(true);
            this._worksheetShareService.deleteWorksheetShare(wksht.Id).subscribe(
              (res) => {
                if (res) {
                  const itemToRemove = this.listShareWorksheets ? this.listShareWorksheets.findIndex((item) => item.Id === wksht.Id) : null;
                  if (itemToRemove) {
                    this.listShareWorksheets.splice(itemToRemove, 1);
                  }
                  if (wksht.Id === this.selectedWorksheetId) {
                    this.selectedWorksheetIndex = null;
                    this.selectedWorksheetId = null;
                  }
                  this.notificationService.success('', Constants.WORKSHEET_MSG010);
                  const newWks = { planID: this.data.id, selectecWksht: this.selectedWorksheetId };
                  this._worksheetShareService._reloadWorksheetAfterNewAction.next(newWks);
                } else {
                  this.isRequestServerOnOff(false);
                  this.notificationService.error('', Constants.WORKSHEET_MSG004);
                }
              },
              (error) => {
                this.isRequestServerOnOff(false);
                this.notificationService.error('', Constants.WORKSHEET_MSG004);
              }
            );
          }
        });
      }
    }
  }

  editingWorksheetShare(id) {
    if (id === this.doubleClickedTab) {
      return true;
    } else {
      return false;
    }
  }

  doEditTitleWorksheetShare(id) {
    event.stopPropagation();
    this.listShareWorksheets.forEach((item) => {
      if (item.Id === id) {
        this.doubleClickedTab = id;
      }
    });
  }

  renameWorksheetShare(event, id) {
    this.doubleClickedTab = null;
    const wkName = event.target.value;
    if (wkName && wkName.trim() === '') {
      this.notificationService.warn('', Constants.WORKSPACE_MSG013);
    } else if (this.listShareWorksheets && this.listShareWorksheets.length > 0 && this.listShareWorksheets.find((x) => x.Title.toUpperCase() === wkName.toUpperCase())) {
      this.notificationService.warn('', Constants.WORKSHEET_MSG009);
      return;
    } else {
      const selectedWorksheetIndex = this.listShareWorksheets ? this.listShareWorksheets.findIndex((x) => x.Id === id) : null;
      if (selectedWorksheetIndex >= 0) {
        const worksheetSelected = this.listShareWorksheets[selectedWorksheetIndex];
        const operationType = { operation: CrudOperationEnum.PUT, oldName: worksheetSelected.Title, selectedWorksheetIndex: selectedWorksheetIndex };
        worksheetSelected.Title = wkName.toUpperCase();
        this.updateWorksheetShare(worksheetSelected, true, operationType);
      } else {
        this.notificationService.warn('', Constants.WORKSHEET_MSG002);
      }
    }
  }

  updateWorksheetShare(wksht: WorksheetShareModel, showMessage?, operationType?) {
    this.isRequestServerOnOff(true);
    this._worksheetShareService.updateWorksheetShare(wksht).subscribe(
      (res) => {
        if (res && res._isScalar !== false) {
          if (showMessage) {
            this.notificationService.success('', Constants.WORKSHEET_MSG005);
          }
          if (operationType && operationType.operation === CrudOperationEnum.DELETE) {
            this.onRemoveSelected();
          }
          AppUtils.orderObjectStringAsc(this.listShareWorksheets, 'Title');
          const newWks = { planID: this.data.id, selectecWksht: res.Id };
          this._worksheetShareService._reloadWorksheetAfterNewAction.next(newWks);
        } else {
          if (operationType && operationType.operation === CrudOperationEnum.PUT) {
            this.listShareWorksheets[operationType.selectedWorksheetIndex].Title = operationType.oldName;
          }
          this.isRequestServerOnOff(false);
          this.notificationService.error('', Constants.WORKSHEET_MSG004);
        }
      },
      () => {
        this.isRequestServerOnOff(false);
        this.notificationService.error('', Constants.WORKSHEET_MSG004);
      }
    );
  }

  newWorksheetShare() {
    const assets = [];
    if (this.isFirstGetWorksheetShare) {
      if (this.data && this.data.symbol !== '') {
        const listSymboltemp = this.data && this.data.symbol ? this.data.symbol.split(',') : [];
        if (listSymboltemp && listSymboltemp.length > 0) {
          listSymboltemp.forEach((element, index) => {
            const newSymbol = { symbol: element, company: '' };
            assets.push(newSymbol);
          });
        }
      }
    }
    // Gera um nome único para a nova planilha, evitando duplicidade mesmo com incrementos
    const baseName = Constants.WKSHT_PLAN_DEFAULT;
    let qtdNew = 0;
    let nameWksTemp = baseName;
    const existingNames = this.listShareWorksheets ? this.listShareWorksheets.filter((ws) => ws.Title && ws.Title.toUpperCase().startsWith(baseName.toUpperCase())).map((ws) => ws.Title.toUpperCase()) : [];

    // Busca o menor número disponível para o nome sugerido
    if (existingNames.length > 0) {
      // Regex para extrair número ao final do nome
      const usedNumbers = existingNames
        .map((name) => {
          const match = name.match(new RegExp(`^${baseName.toUpperCase()}\\s*(\\d+)?$`));
          return match && match[1] ? parseInt(match[1], 10) : name === baseName.toUpperCase() ? 0 : null;
        })
        .filter((num) => num !== null);

      // Encontra o menor número não utilizado
      let nextNumber = 0;
      while (usedNumbers.includes(nextNumber)) {
        nextNumber++;
      }
      nameWksTemp = nextNumber === 0 ? baseName : `${baseName} ${nextNumber}`;
    }

    // Impede nome duplicado
    if (existingNames.includes(nameWksTemp.toUpperCase())) {
      this.notificationService.warn('', Constants.WORKSHEET_MSG009);
      return;
    }
    this.isRequestServerOnOff(true);
    if (!this.isWksOffline && this.configService.getCookieWorkspace()) {
      this._worksheetShareService.newWorksheetShare(assets, nameWksTemp).subscribe(
        (res) => {
          if (res) {
            if (this.isFirstGetWorksheetShare) {
              this.data.symbol = null;
              this.isFirstGetWorksheetShare = false;
            }
            this.listShareWorksheets.push(res);
            AppUtils.orderObjectStringAsc(this.listShareWorksheets, 'Title');
            this.saveWorsheetSelected(res.Id);
            const newWks = { planID: this.data.id, selectecWksht: res.Id };
            this._worksheetShareService._reloadWorksheetAfterNewAction.next(newWks);
          } else {
            this.isRequestServerOnOff(false);
            this.notificationService.error('', Constants.WORKSHEET_MSG007);
          }
        },
        () => {
          this.isRequestServerOnOff(false);
          this.notificationService.error('', Constants.WORKSHEET_MSG007);
        }
      );
    } else {
      if (this.listShareDefaultWorksheets && this.listShareDefaultWorksheets.length <= 0) {
        this.isRequestServerOnOff(false);
        this.worksheetSelected.Title = '';
      }
    }
  }

  saveWorsheetSelected(id) {
    if (id) {
      this.oldSelectedWorksheetId = this.selectedWorksheetId;
      this.data.data.selected_worksheet = id;
      this.data.selected_worksheet = id;
      this.selectedWorksheetId = id;
      this.configService.writeLog(id, Constants.WINDOW_NAME_WORK_SHEET + ' > saveWorsheetSelected() > PlanID: ' + this.data.id + ' - ID: ' + id);
      if (this.worksheetFirstLoaded) {
        super.updateOnDemand(null, '');
      }
      this.worksheetFirstLoaded = true;
    }
  }

  isRequestServerOnOff(isRequestServer: boolean) {
    this.isRequestServer = isRequestServer;
  }
}
